import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FormDate, FormDateTime, FormInput, FormSelect, FormTextarea } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { EncounterFieldLabel } from "./field-label";
import { getValidationValue } from "./get-validation-value";
/** Renders a single outbound config field as the matching Mantine control. */
export function EncounterFieldInput(_ref) {
  var field = _ref.field,
    dropdowns = _ref.dropdowns,
    value = _ref.value,
    _onChange = _ref.onChange,
    invalid = _ref.invalid,
    requiredOverride = _ref.requiredOverride;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var testId = "encounter-field-".concat(field.name);
  var showNow = field.name.toLowerCase().includes("start");
  var required = Boolean(field.required || requiredOverride);
  var maxLength = getValidationValue(field.validations, "max_length");
  var fieldLabel = /*#__PURE__*/React.createElement(EncounterFieldLabel, {
    label: field.label,
    required: required,
    validations: field.validations
  });
  if (field.type === "dropdown") {
    var _ref2, _ref3;
    var rawOptions = (_ref2 = (_ref3 = field.options_ref ? dropdowns[field.options_ref] : undefined) !== null && _ref3 !== void 0 ? _ref3 : field.options) !== null && _ref2 !== void 0 ? _ref2 : [];
    var data = rawOptions.map(function (option) {
      return {
        value: option.value,
        label: option.label
      };
    });
    return /*#__PURE__*/React.createElement(FormSelect, {
      label: fieldLabel,
      placeholder: t("select", {
        defaultValue: "Select…"
      }),
      data: data,
      value: value || null,
      onChange: function onChange(next) {
        trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FIELD, {
          field: field.name
        });
        _onChange(next !== null && next !== void 0 ? next : "");
      },
      searchable: true,
      clearable: true,
      withinPortal: true,
      error: invalid,
      "data-testid": testId
    });
  }
  if (field.type === "textarea") {
    return /*#__PURE__*/React.createElement(FormTextarea, {
      label: fieldLabel,
      minRows: 3,
      maxLength: maxLength,
      showCharacterCount: maxLength != null,
      value: value,
      onChange: function onChange(event) {
        return _onChange(event.currentTarget.value);
      },
      error: invalid,
      "data-testid": testId
    });
  }
  if (field.type === "datetime") {
    return /*#__PURE__*/React.createElement(FormDateTime, {
      label: fieldLabel,
      value: value,
      onChange: function onChange(next) {
        trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FIELD, {
          field: field.name
        });
        _onChange(next);
      },
      testId: testId,
      showNow: showNow,
      error: invalid
    });
  }
  if (field.type === "date") {
    return /*#__PURE__*/React.createElement(FormDate, {
      label: fieldLabel,
      value: value,
      onChange: function onChange(next) {
        trackEvent(ANALYTICS_EVENTS.ENCOUNTER_FIELD, {
          field: field.name
        });
        _onChange(next);
      },
      testId: testId,
      showNow: showNow,
      error: invalid
    });
  }
  return /*#__PURE__*/React.createElement(FormInput, {
    label: fieldLabel,
    type: "text",
    maxLength: maxLength,
    showCharacterCount: maxLength != null,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.currentTarget.value);
    },
    error: invalid,
    "data-testid": testId
  });
}